import {
  set
} from '../redux/activities'
import _requestRemoveBookmark from 'store/sagas/requestRemoveBookmark'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  activityId: number
}

const requestRemoveBookmark = (payload: Payload) => async dispatch => {
  const { cardId, activityId } = payload

  const optimisticAction = optimisticDispatch(dispatch, set({
    cardId,
    activity: {
      id: activityId,
      isBookmarked: false
    }
  }))

  try {
    await dispatch(_requestRemoveBookmark({
      id: activityId,
    }))

    if (optimisticAction) {
      optimisticAction.commit()
    }
  } catch (error) {
    if (optimisticAction) {
      optimisticAction.revert()
    }

    throw error
  }
}

export default requestRemoveBookmark
